import Service from './service'

export default class PortfolioService {
  /**
   * Récupère les tâches ouvertes dans le portfolio
   * @param {string} email
   */
  static async getOpenTasks (email) {
    try {
      return await Service.portfolioApi.post('/opentasks', {
        user: email
      }, {
        headers: Service.getPortfolioAuthHeader(Service.portfolioToken)
      })
    } catch (error) {
      // L'api portfolio retourne 404 quand l'utilisateur n'a pas de tâches ouvertes
      if (error.response.data.status.code && error.response.data.status.code !== 404) {
        Service.handleError(error)
      }
    }
  }
}
